export const defs = (...defs) => ["defs", {}, ...defs];
